import CONFIGURABLE_CONSTANTS from 'constants/configurable.constants';
import { FunctionComponent } from 'preact';
import { useEffect, useState } from 'preact/compat';
import { MapUnavailable } from '../MapUnavailable';
import { LoadingContainer, MapIframe } from './MapView.styles';

interface MapViewProps {
  center?: google.maps.LatLng | google.maps.LatLngLiteral;
  isDropOffEmpty: boolean;
  isViewOnlyMode?: boolean;
}

const MapView: FunctionComponent<MapViewProps> = ({
  center,
  isDropOffEmpty,
  isViewOnlyMode = false,
}): JSX.Element => {
  const [isLoadingIframe, setIsLoadingIframe] = useState(true);

  // for resetting loading state when center has changed, i.e click to another collection point
  useEffect(() => {
    setIsLoadingIframe(true);
  }, [center?.lat, center?.lng]);

  if (isDropOffEmpty) {
    return <MapUnavailable />;
  }

  if (!center) return null;

  // Reference: https://developers.google.com/maps/documentation/embed/embedding-map
  const iframeSrc = `https://www.google.com/maps/embed/v1/place?key=${CONFIGURABLE_CONSTANTS.googleApiKey}&q=${center.lat},${center.lng}`;

  return (
    <>
      {/* Cannnot do if (loading) <Loading /> because iframe onLoad must be called */}
      {isLoadingIframe && <LoadingContainer data-testid="map-view-loading" />}
      <MapIframe
        data-testid="map-view-iframe"
        isViewOnlyMode={isViewOnlyMode}
        title="Drop Off Locations Map"
        src={iframeSrc}
        isLoading={isLoadingIframe}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        onLoad={() => setIsLoadingIframe(false)}
      />
    </>
  );
};

export { MapView };
